import React, { useEffect, useState } from 'react';

const getFullscreenElement = () =>
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;

const FullScreenDropdown = () => {
    /*
    mode
    */
    const [isFullScreenMode, setIsFullScreenMode] = useState(true);

    /*
    keep body class / icon in sync with the browser (also covers leaving full screen with Esc)
    */
    useEffect(() => {
        const changeHandler = () => {
            const isFullscreen = !!getFullscreenElement();
            setIsFullScreenMode(!isFullscreen);
            if (isFullscreen) {
                document.body.classList.add("fullscreen-enable");
            } else {
                document.body.classList.remove("fullscreen-enable");
            }
            // close the collapsed (hamburger) menu when entering / leaving full screen
            document.body.classList.remove("menu");
            const hamburgerIcon = document.querySelector(".hamburger-icon");
            if (hamburgerIcon) hamburgerIcon.classList.remove("open");
            window.dispatchEvent(new Event('resize'));
        };
        document.addEventListener("fullscreenchange", changeHandler);
        document.addEventListener("webkitfullscreenchange", changeHandler);
        document.addEventListener("mozfullscreenchange", changeHandler);
        return () => {
            document.removeEventListener("fullscreenchange", changeHandler);
            document.removeEventListener("webkitfullscreenchange", changeHandler);
            document.removeEventListener("mozfullscreenchange", changeHandler);
        };
    }, []);

    /*
    full screen
    */
    const toggleFullscreen = () => {
        if (!getFullscreenElement()) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    };
    return (
        <React.Fragment>
            <div className="ms-1 header-item d-none d-sm-flex">
                <button
                    onClick={toggleFullscreen}
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >
                    <i className={isFullScreenMode ? 'bx bx-fullscreen fs-24' : "bx bx-exit-fullscreen fs-24"}></i>
                </button>
            </div>
        </React.Fragment>
    );
};

export default FullScreenDropdown;
